import { lazy, Suspense } from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { PageReady } from '@app/PageReady';
import { PageMe } from '@pages/me';
import { ScriptExport } from "@pages/aiStudio/ScriptExport";
import { ScriptRewrite } from "@pages/aiStudio/ScriptRewrite";
import { ScriptReview } from '@pages/aiStudio/ScriptReview';
import { Library } from '@pages/library/Library';
import { PageTheme } from '@pages/theme';
import PageImage from '@pages/image';
import PageVideo from '@pages/video';
import { PageVideoCreating } from '@pages/videoCreating';
import { PageTiktokShopAuth } from '@pages/tiktokShopAuthCallback/PageTiktokShopAuth';
import { SocialPublisher } from '@pages/SocialPublisher/SocialPublisher';
import { PagePrivacyPolicy } from "@pages/privacyPolicy";
import { VideoRemakeStudioPage } from '@pages/videoRemake/VideoRemakeStudioPage';
import { VideoRemakeWelcomePage } from '@pages/videoRemake/VideoRemakeWelcomePage';

const PageHome = lazy(() => import("@pages/home/index") as any);

export const LoginRouter = () => {
  return (
    <Suspense>
      <Routes>
        <Route path="/login" element={<PageReady noSider><PageHome /></PageReady>} />
        <Route path="/authorization" element={<PageReady noSider><PageHome /></PageReady>} />
        <Route path="/signup" element={<PageReady noSider><PageHome /></PageReady>} />
        <Route path="/add-password" element={<PageReady noSider><PageHome /></PageReady>} />
        <Route path="/reset-password" element={<PageReady noSider><PageHome /></PageReady>} />
        <Route path="/privacy-policy" element={<PagePrivacyPolicy />} />

        <Route path="/video" element={<PageReady><PageVideo /></PageReady>} />
        <Route path="/video-creating" element={<PageReady><PageVideoCreating /></PageReady>} />
        <Route path="/video-remake" element={<PageReady><Outlet /></PageReady>}>
          <Route index element={<Navigate to="welcome" replace />} />
          <Route path="welcome" element={<VideoRemakeWelcomePage />} />
          <Route path="studio" element={<VideoRemakeStudioPage />} />
        </Route>
        <Route path="/image" element={<PageReady><PageImage /></PageReady>} />
        <Route path="/me" element={<PageReady><PageMe /></PageReady>} />
        <Route path="/theme" element={<PageReady><PageTheme /></PageReady>} />
        <Route path="/insight" element={<PageReady><ScriptExport /></PageReady>} />
        <Route path="/script-rewrite" element={<PageReady><ScriptRewrite /></PageReady>} />
        <Route path="/script-review" element={<PageReady><ScriptReview /></PageReady>} />
        <Route path="/library" element={<PageReady><Library /></PageReady>} />
        <Route path="/tiktok-shop-auth-callback" element={<PageReady noSider><PageTiktokShopAuth /></PageReady>} />
        <Route path="/social-publisher" element={<PageReady><SocialPublisher /></PageReady>} />
        <Route path="*" element={<Navigate to="/video" replace />} />
      </Routes>
    </Suspense>
  );
};
